import React from "react";
import { useForm } from "react-hook-form";
// css
import classes from "./Profile.module.css";
import CustomBreadCrumbs from "../../components/CustomBreadCrumbs";
import { EyeIconWrapper, LabelInput } from "../../Utils/CustomComponent";
import { changePasswordFormOptions } from "../../Utils/formOptions";
import urls from "../../Utils/urls";
import axios from "../../axios";
import { toast } from "react-toastify";
import { commonToast } from "../../Utils";

const ChangePassword = () => {
  const {
    register,
    handleSubmit,
    setError,
    formState: { errors },
    watch,
  } = useForm(changePasswordFormOptions);

  const currentPassword = watch("currentPassword");
  const user = JSON.parse(localStorage.getItem("user"));
  const parsedUser = JSON.parse(user.config.data);

  const onSubmit = async (data2) => {
    // postChangePassword
    if (currentPassword !== parsedUser.password) {
      setError("currentPassword", {
        type: "custom",
        message: "Invalid Password!",
      });
      return;
    }
    const id = toast.loading("Changing Password");
    try {
      if (data2.reEnterNewPassword != data2.newPassword) {
        toast.update(id, {
          render: "Password don't match",
          type: "error",
          isLoading: false,
          ...commonToast,
        });
        return;
      }
      // const headers = {
      //   headers: {
      //     "Content-Type": "application/json",
      //   },
      // };
      const userId = localStorage.getItem("apex_userid");
      // let data = JSON.stringify({
      //   user_id: userId,
      //   password: data2.reEnterNewPassword,
      // });
      // const res = await axios.post(
      //   urls.profile.postChangePassword,
      //   data,
      //   headers
      // );
      const headers = {
        headers: {
          Authorization: "Basic UkVTVEFQSUxPQU5MSU5ROjg4V2VIZWxwVSQjQA==",
        },
      };

      const res = await axios.post(
        urls.newBorrowerLogin.setPassword,
        {
          user_id: userId,
          password: data2.reEnterNewPassword,
          type: "U",
          email_address: "",
        },
        headers
      );
      if (res?.data?.status === "200") {
        toast.update(id, {
          render: "Password Changed Succesfuly",
          type: "success",
          isLoading: false,
          ...commonToast,
        });
      }
    } catch (error) {
      toast.update(id, {
        render: "Error " + error.message,
        type: "error",
        isLoading: false,
        ...commonToast,
      });
    } finally {
      setTimeout(() => {
        toast.dismiss();
      }, 1000);
    }
  };
  return (
    <div>
      <section
        className="rounded container-fluid"
        style={{ background: "#eeeeee", minHeight: "100vh" }}
      >
        <div className="p-3 pb-0  mt-1">
          <CustomBreadCrumbs
            crumbs={[
              { title: "Profile", link: "/manage-account" },
              { title: "Change Password", link: "" },
            ]}
          />
          <div className={`${classes.bgWhite} ${classes.changePassword}`}>
            <form>
              <div className="d-flex" style={{ gap: "38px" }}>
                <EyeIconWrapper top="35px" inputProps={true}>
                  <div
                    className="form-group w-50"
                    style={{ marginBottom: "30px" }}
                  >
                    <LabelInput
                      labelProps={{
                        title: "Current Password",
                        props: {
                          htmlFor: "currentPassword",
                        },
                        className: classes.labelEditProfile,
                      }}
                      inputProps={{
                        className: `form-control ${
                          errors.currentPassword ? "is-invalid" : ""
                        }`,
                        type: "text",
                        id: "currentPassword",
                        placeholder: "Current Password",
                        ...register("currentPassword"),
                      }}
                      error={errors.currentPassword?.message}
                    />
                  </div>
                </EyeIconWrapper>
                <span className="w-50">{null}</span>
              </div>
              <div
                className="d-flex"
                style={{ gap: "38px", marginBottom: "30px" }}
              >
                <EyeIconWrapper top="35px" inputProps={true}>
                  <div className="form-group w-50">
                    <LabelInput
                      labelProps={{
                        title: "New Password",
                        props: {
                          htmlFor: "newPassword",
                        },
                        className: classes.labelEditProfile,
                      }}
                      inputProps={{
                        className: `form-control ${
                          errors.newPassword ? "is-invalid" : ""
                        }`,
                        type: "password",
                        id: "newPassword",
                        placeholder: "New Password",
                        ...register("newPassword"),
                      }}
                      error={errors.newPassword?.message}
                    />
                  </div>
                </EyeIconWrapper>
                <EyeIconWrapper top="35px" inputProps={true}>
                  <div className="form-group w-50">
                    <LabelInput
                      labelProps={{
                        title: "Re-Enter New Password",
                        props: {
                          htmlFor: "reEnterNewPassword",
                        },
                        className: classes.labelEditProfile,
                      }}
                      inputProps={{
                        className: `form-control ${
                          errors.reEnterNewPassword ? "is-invalid" : ""
                        }`,
                        type: "password",
                        id: "reEnterNewPassword",
                        placeholder: "Re-Enter New Password",
                        ...register("reEnterNewPassword"),
                      }}
                      error={errors.reEnterNewPassword?.message}
                    />
                  </div>
                </EyeIconWrapper>
              </div>
              <button
                className="btn my-2 btn-lg btn-primary btn-block m-auto text-white py-4"
                style={{ fontWeight: "500", fontSize: "18px" }}
                onClick={handleSubmit(onSubmit)}
              >
                Save Password
              </button>
            </form>
          </div>
        </div>
      </section>
    </div>
  );
};

export default ChangePassword;
